import { Typography, TypographyProps } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { merge } from 'lodash'

export interface KFieldLabelProps extends TypographyProps {
  required?: boolean
  labelSize?: 'small' | 'medium' | 'large'
}

export const KFieldLabel = ({
  required,
  labelSize,
  sx,
  children,
  ...props
}: KFieldLabelProps) => {
  const theme = useTheme()
  const labelSizeProps =
    labelSize === 'small'
      ? theme.typography.h6
      : labelSize === 'large'
      ? theme.typography.h4
      : theme.typography.h5

  return (
    <Typography
      {...props}
      sx={merge(
        {
          color: theme.palette.secondary.main,
        },
        labelSizeProps,
        sx as any,
      )}
    >
      {children}
      {required && (
        <span
          style={{
            color: theme.palette.error.main,
            marginLeft: 0.5,
          }}
        >
          *
        </span>
      )}
    </Typography>
  )
}
